// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:32:57

export default {
  "id": "save-my-pet",
  "slug": "save-my-pet",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/60ef594a68ba462b9c32178de94dcdc9-200x120.jpg",
  "gameUrl": "https://html5.gamedistribution.com/60ef594a68ba462b9c32178de94dcdc9/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Save My Pet",
      "description": "Save My Pet is a fun and addictive puzzle game where you must protect your adorable pet from a swarm of angry bees! Using your creativity, draw a protective barrier around your pet to keep it safe from danger. But be careful, your lines must hold for a few seconds while the bees try to break through! With increasing difficulty, unique challenges, this game will test your problem-solving skills and quick thinking.\nCan you keep your pet safe from harm?\nPlay Save My Pet now and find out!",
      "instructions": "Follow the game instructions!",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "rescue"
      ]
    },
    "zh-CN": {
      "title": "拯救我的宠物",
      "description": "《救我的宠物》是一款有趣且上瘾的益智游戏，你必须保护你可爱的宠物免受一群愤怒蜜蜂的攻击！运用你的创造力，为你的宠物画一个保护屏障，让它远离危险。但要注意，你的线条必须维持几秒钟，直到蜜蜂试图突破！随着难度的增加，独特的挑战，这款游戏将考验你的解决问题的能力和快速思考。\n你能让你的宠物免受伤害吗？\n现在就玩《救我的宠物》来揭晓答案吧！",
      "instructions": "遵循游戏说明！",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "营救"
      ]
    },
    "zh-TW": {
      "title": "拯救我的寵物",
      "description": "救我寵物是一款有趣且上癮的謎題遊戲，您必須保護您可愛的寵物，讓它逃離一群愤怒的蜂群！利用您的創造力，繪製一個保護屏障來保護您的寵物，避免危險。但請小心，您的線必須維持幾秒鐘，讓蜂群試圖突破！隨著難度的增加，獨特的挑戰，這款遊戲將考驗您的問題解決能力和敏捷思考。\n\n您能夠保護您的寵物不受傷害嗎？\n現在就玩救我寵物，看看結果如何吧！",
      "instructions": "依照遊戲指示進行！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "救援"
      ]
    },
    "zh-HK": {
      "title": "拯救我的寵物",
      "description": "救我寵物是一款有趣且上癮的益智遊戲，你要保護你可愛的寵物免受一群怒蜂的攻擊！運用你的創意，為你的寵物畫一個保護屏障，讓它安全無虞。但請小心，你的線條必須維持幾秒鐘，讓蜜蜂嘗試破壞！隨著難度的增加，獨特的挑戰，這款遊戲將測試你的解題技巧和快速思考。\n你能夠保護你的寵物免受傷害嗎？\n現在就玩救我寵物，看看結果如何！",
      "instructions": "遵照遊戲指示！",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "拯救"
      ]
    },
    "ja": {
      "title": "ペットを救ってください",
      "description": "「Save My Pet」は楽しい魅力的なパズルゲームで、あなたの愛らしいペットを怒った蜂の群れから守る必要があります。あなたの創造力を使って、ペットを危険から守る防護バリアを描いてください。しかし、注意してください、あなたの線は蜂が突破しようとする数秒間のみ持ちます！難易度が高くなるにつれて、ユニークな挑戦がこのゲームであなたの問題解決スキルと速い思考を試します。\n\nあなたのペットを怪我から守ることができますか？\n「Save My Pet」を今すぐプレイして、その結果を見つけてください！",
      "instructions": "ゲームの説明をよく読んでください！",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "救援"
      ]
    },
    "ko": {
      "title": "내 펫을 구해줘",
      "description": "Save My Pet는 귀여운 반려동물을 한 무리의 화가운 벌로부터 보호해야 하는 재미있고 중독성이 있는益智패uzzle 게임입니다! 창의력을 사용하여 반려동물 주위에 보호벽을 그려서 위험에서 안전하게 지키세요. 하지만 주의하세요, 벌들이 통과하려고 시도하는 동안 선들은 몇 초 동안 지속되어야 합니다! 점진적으로 어려워지는 난이도와 독특한 도전으로, 이 게임은 문제 해결 능력과 빠른 사고력을 테스트합니다.\n귀하의 반려동물을 안전하게 지킬 수 있을까요?\n지금 Save My Pet을 플레이하고 알아보세요!",
      "instructions": "게임 지시를 따르세요!",
      "genres": [
        "캐주얼",
        "패uzzle"
      ],
      "tags": [
        "구조"
      ]
    },
    "fr": {
      "title": "Sauve-moi mon animal de compagnie",
      "description": "Sauve-moi mon animal de compagnie est un jeu de puzzle amusant et accrocheur où vous devez protéger votre adorable animal de compagnie d'une nuée d'abeilles en colère ! Utilisez votre créativité pour dessiner une barrière protectrice autour de votre animal pour le garder en sécurité des dangers. Mais soyez prudent, vos lignes doivent tenir quelques secondes pendant que les abeilles tentent de s'enfoncer ! Avec une difficulté croissante et des défis uniques, ce jeu mettra à l'épreuve vos compétences en résolution de problèmes et votre pensée rapide.\nPouvez-vous garder votre animal en sécurité ?\nJouez à Sauve-moi mon animal de compagnie maintenant et le découvrez !",
      "instructions": "Suivez les instructions du jeu !",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "Sauvetage"
      ]
    }
  }
};
